import React from 'react'
import styled from 'styled-components'
import {Button} from 'grommet/components/Button'

const StyledTabButton = styled(Button)`
  width: 240px;
  height: 60px;
  font-size: 14px;
  border-radius: 32px;
  margin: 10px;
  box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.05);
  font-weight: 600;
  background-color: white;
  text-align: center;

  @media (max-width: 1024px) {
    height: 55px;
    font-size: 13px;
    width: 210px;
  }
`

const TabButton = props => (
  <StyledTabButton
    onClick={() => props.onClick(props.action)}
    data-testid={props.dataTestid || 'tab-button'}
  >
    {props.label}
  </StyledTabButton>
)

export default TabButton
